import WebServiceRequest from "../../Api/WebServiceRequest";

class UserReportDetailsRequest extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("UserReport/Get");
  }
  setParams(data) {
    super.setRequestParam(data);
  }
}
export default UserReportDetailsRequest;
